import { Typography, styled } from '@mui/material';

export { default as PageTitle } from './PageTitle';
export const CopyText = styled(Typography)({
	textAlign: 'left',
	marginBottom: '1rem',
});
